import React, {useState} from "react";
import {TableCellAlignments, TableCellTypes} from "../../../../../../../../core/constants/enums";
import {useTranslation} from "react-i18next";
import {Select} from "../../../../../../../components/base/select/select";
import Table from "../../../../../../../containers/table";
import {Col} from "react-bootstrap";
import NoEntries from "../../../../../../../components/app-specific/no-entries";

//Keys for the participants table
const reportsTableCellKeys = {
    reportTypes: 'reportTypes',
    export: 'export',
}

const SpireCountingReports = ({data, loading}) => {
    const [selectedReportType, setSelectedReportType] = useState(data?.reports?.reportTypes[0])
    const {t} = useTranslation();
    const translation = t('views.panel.company.counting.spire.single', {returnObjects: true});
    const errorMessage = t('views.panel.errorMessages', {returnObjects: true})

    const reportsTableCells = [
        {
            title: translation?.reportTable?.reportTypes ?? '',
            alignment: TableCellAlignments.left,
            type: TableCellTypes.string,
            name: reportsTableCellKeys.reportTypes,
            size: 1
        },
        {
            title: translation?.reportTable?.export ?? '',
            alignment: TableCellAlignments.right,
            type: TableCellTypes.element,
            name: reportsTableCellKeys.export,
            size: 0,
        },
    ];

    /**
     * Handles changes in the report type:
     * Sets the [selectedReportTypeId] in the state based on the selected report
     */
    const onReportTypeChanged = (e) => {
        console.log(e.target.value.id); //-> the id of the selected field
        setSelectedReportType(e?.target?.value);
        // setSelectedReportTypeId()
    }

    /**
     * Downloads the selected report
     * @param report
     */
    const onDownloadClicked = (report) => {

    }

    /**
     * Creates the data entries for the reports table
     * @return {TableData[]}
     */
    const createReportTable = () => {
        let reportsToShow = data.reports?.reportList?.filter(e => e.typeId === selectedReportType?.id)
        return reportsToShow.map((report) => ({
            key: report?.id,
            [reportsTableCellKeys.reportTypes]: report?.title,
            [reportsTableCellKeys.export]: () => (
                <div className={'download-button'} onClick={(report) => onDownloadClicked}>
                    <p>{translation?.download}</p>
                </div>
            ),
        }));
    }


    return (
        <>
            <div className={"spire-counting-single-reports"}>
                <Col xs={12} xl={7}>
                    <Select
                        name={'report-format'}
                        value={selectedReportType?.title}
                        placeholder={translation?.reportFormat ?? ''}
                        label={translation?.reportFormat ?? ''}
                        onChange={onReportTypeChanged}

                        data={data?.reports?.reportTypes?.map(e => ({
                            id: e.id,
                            value: e
                        }))}
                    />
                </Col>
                <Col xs={12} xl={7}>
                    {
                        data.reports?.reportList?.length < 1 && !loading
                            ? <NoEntries
                                text={errorMessage}
                                includeButton={false}
                            />
                            : <Table
                                loading={{state: loading, count: 3}}
                                className={'my-3 w-75 '}
                                color={'primary'}
                                cells={reportsTableCells}
                                data={createReportTable()}
                            />

                    }
                </Col>
            </div>
        </>
    );
}

export default SpireCountingReports;
